import { render } from "./StudyPlanCounter.vue?vue&type=template&id=a888ff94"
import script from "./StudyPlanCounter.vue?vue&type=script&lang=js"
export * from "./StudyPlanCounter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__